// extracted by mini-css-extract-plugin
export default {"tabContainer":"labeltypetabs_tabContainer__0PWcU","tabBtn":"labeltypetabs_tabBtn__Ktisp","active":"labeltypetabs_active__Upv-f"};